

export default function Pagination () {
  return (
    <div className="blog__pagination">
      <span className="blog__pagination--active">01</span>
      <span>02</span>
      <span>03</span>
      <span>...</span>
      <span className="next-btn">Next</span>
    </div>
  )
}